import React, { useContext, useEffect, useRef } from "react";
import styles from "./CoverVacancies.module.scss";
import MobileContext from "../../context/mobile";
import PathContext from "../../context/path";
import Figure from '../Figure';
import Constructions from '../Constructions/Constructions';
const CoverVacancies = () => {
  const path = useContext(PathContext);

  const isMobile = useContext(MobileContext);
  const refContruction = useRef(null);


  return (
    <>
      <div className={styles.wrap}>
        <div className={styles.inner}>
          <h1 className={styles.title}>Найдите работу <br /> в Р-Фарм</h1>
          <div className={styles.text}>
            <p>Используйте фильтры в правой части экрана и подберите подходящую вакансию.</p>
          </div>

          <div className={styles.constructions} ref={refContruction}>
            <Constructions color={'green'} />
          </div>
        </div>
      </div>
    </>
  );

}

export default CoverVacancies;
